import representPdf from '@/assets/BEA Letter DC Bihar.pdf';
import beaLetterDcBiharNew from '@/assets/BEA LETTER DC BIHAR 300326 NEW.pdf';
import beaMopngSecy from '@/assets/BEA_MOPNG_SECY_311025.pdf';
import beaLetterDoiHim from '@/assets/BEA_LETTER_DOI_HIM_021225.pdf';
import beaExciseLetterMerged from '@/assets/BEA 050526 EXCISE LETTER MERGED.pdf';
import indiaNepalPartnership from '@/assets/India-Nepal-Partnership-for-E10-Fuel-Supply-and-Ethanol-Cooperation (1).pdf';
import annx1BpaEoi1 from '@/assets/ANNX1_BPA_EOI1.pdf';
import annx2BpaEoi2Extract from '@/assets/ANNX2_BPA_EOI2_EXTRACT.pdf';
import annx3Esy2425Extract from '@/assets/ANNX3_ESY24-25_TENDER_EXTRACT.pdf';
import annx4Esy2526Extract from '@/assets/ANNX4_ESY25-26_TENDER_EXTRACT.pdf';

export type DocumentCategory = 'all' | 'representation' | 'whitepaper' | 'annexure';

export interface RepresentDocument {
  id: string;
  title: string;
  shortTitle: string;
  category: 'representation' | 'whitepaper' | 'annexure';
  categoryLabel: string;
  authority: string;
  authorityType: 'State Government' | 'Central Government' | 'OMC Procurement' | 'Strategic Policy';
  date: string;
  referenceNo?: string;
  summary: string;
  pdfUrl: string;
  pageCount: string;
  fileSize: string;
  tags: string[];
  featured?: boolean;
}

export const representDocuments: RepresentDocument[] = [
  {
    id: 'bea-letter-dc-bihar',
    title: 'Representation Letter - DC Bihar',
    shortTitle: 'DC Bihar: Nepal EBP Market Access',
    category: 'representation',
    categoryLabel: 'State Representation',
    authority: 'Development Commissioner, Bihar',
    authorityType: 'State Government',
    date: '30 Mar 2026',
    referenceNo: 'BEA/DCB/2026/01',
    summary:
      'Formal memorandum requesting Bihar Government intervention to position Bihar-based ethanol distilleries as preferred suppliers to Nepal Oil Corporation under Nepal\'s newly notified "Order on Use of Ethanol Blended Petrol, 2082".',
    pdfUrl: representPdf,
    pageCount: '3 Pages',
    fileSize: '400 KB',
    tags: ['Nepal EBP', 'Export Facilitation', 'Bilateral Supply', 'State Advocacy'],
    featured: true,
  },
  {
    id: 'bea-letter-dc-bihar-new',
    title: 'Representation Letter - DC Bihar (Revised & Updated)',
    shortTitle: 'DC Bihar: Updated Nepal EBP Protocol',
    category: 'representation',
    categoryLabel: 'State Representation',
    authority: 'Development Commissioner, Bihar',
    authorityType: 'State Government',
    date: '31 Mar 2026',
    referenceNo: 'BEA/DCB/2026/02-REV',
    summary:
      'Subsequent updated representation regarding Nepal Oil Corporation ethanol procurement, highlighting logistical proximity, direct cross-border supply lines, and competitive ex-mill ethanol tariffs from Bihar.',
    pdfUrl: beaLetterDcBiharNew,
    pageCount: '3 Pages',
    fileSize: '393 KB',
    tags: ['Nepal EBP', 'Cross-Border Logistics', 'Export Policy', 'Updated Filing'],
    featured: true,
  },
  {
    id: 'bea-mopng-secy-311025',
    title: 'Representation to Secretary, MoPNG - ESY 2025-26 Allocation',
    shortTitle: 'MoPNG: ESY 2025-26 Quota Revision',
    category: 'representation',
    categoryLabel: 'Central Ministry Submission',
    authority: 'Ministry of Petroleum & Natural Gas (MoPNG), GoI',
    authorityType: 'Central Government',
    date: '31 Oct 2025',
    referenceNo: 'BEA/MOPNG/2025/ESY-26',
    summary:
      'Urgent petition to the Secretary, MoPNG requesting revision in allocation of ethanol quantity for ESY 2025-26 to Bihar-based Dedicated Ethanol Plants (DEPs) holding 10-year Long-Term Offtake Agreements (LTOA) under EOI 01.',
    pdfUrl: beaMopngSecy,
    pageCount: '11 Pages',
    fileSize: '3.1 MB',
    tags: ['MoPNG Allocation', 'ESY 2025-26', 'LTOA Rights', 'Tender 22376'],
    featured: true,
  },
  {
    id: 'bea-letter-doi-him-021225',
    title: "Representation to Hon'ble Minister of Industries, Bihar",
    shortTitle: 'Dept of Industries: State Allocation Support',
    category: 'representation',
    categoryLabel: 'State Representation',
    authority: 'Department of Industries, Government of Bihar',
    authorityType: 'State Government',
    date: '02 Dec 2025',
    referenceNo: 'BEA/DOI/2025/12-01',
    summary:
      'High-level memorandum appealing for Bihar Government backing before the central petroleum ministry to safeguard off-take commitments and production capacities of Bihar grain-based ethanol units.',
    pdfUrl: beaLetterDoiHim,
    pageCount: '7 Pages',
    fileSize: '312 KB',
    tags: ['Industries Dept', 'State Support', 'ESY 2025-26', 'Grain Distilleries'],
  },
  {
    id: 'bea-050526-excise-letter-merged',
    title: 'Representation on Industrial Denaturant Schedule & SOP Amendment',
    shortTitle: 'Excise Dept: Denaturant SOP Amendment',
    category: 'representation',
    categoryLabel: 'Regulatory Submission',
    authority: 'Excise & Prohibition Department, Bihar',
    authorityType: 'State Government',
    date: '05 May 2026',
    referenceNo: 'BEA/EXCISE/2026/SOP-01',
    summary:
      'Comprehensive submission requesting amendment to Order No. 1068 to extend the permissible denaturants list under SOP dated 22.04.2026, aligning with IS 4117:2008 standards for industrial alcohol applications.',
    pdfUrl: beaExciseLetterMerged,
    pageCount: '30 Pages',
    fileSize: '6.2 MB',
    tags: ['Excise SOP', 'Denaturants', 'IS 4117:2008', 'Industrial Ethanol'],
  },
  {
    id: 'india-nepal-partnership',
    title: 'India-Nepal Partnership for E10 Fuel Supply & Ethanol Cooperation',
    shortTitle: 'Whitepaper: India-Nepal Ethanol Corridor',
    category: 'whitepaper',
    categoryLabel: 'Policy Whitepaper',
    authority: 'Cross-Border Energy Bilateral / GEMA',
    authorityType: 'Strategic Policy',
    date: 'March 2026',
    referenceNo: 'GEMA/BEA-NEPAL/2026',
    summary:
      'Strategic policy whitepaper proposing bilateral cooperation leveraging India\'s surplus grain ethanol capacity and Motihari-Amlekhgunj cross-border pipeline infrastructure to supply Nepal Oil Corporation with E10 fuel.',
    pdfUrl: indiaNepalPartnership,
    pageCount: '12 Pages',
    fileSize: '2.3 MB',
    tags: ['Cross-Border Trade', 'Nepal NOC', 'E10 Blending', 'Energy Corridor'],
    featured: true,
  },
  {
    id: 'annx4-esy25-26-tender-extract',
    title: 'Annexure 4: OMC Tender Extract (ESY 2025-26)',
    shortTitle: 'Tender Extract: ESY 2025-26 (1050 Cr L)',
    category: 'annexure',
    categoryLabel: 'OMC Tender Extract',
    authority: 'Oil Marketing Companies (IOCL, BPCL, HPCL)',
    authorityType: 'OMC Procurement',
    date: '23 Sep 2025',
    referenceNo: 'E-Tender No: 22376 (Ref 1000442332)',
    summary:
      'Official tender extract for supply of ~1050 crore litres of denatured anhydrous ethanol at OMC locations for Ethanol Supply Year (ESY) 2025-26, including allocation terms and DEP supply quotas.',
    pdfUrl: annx4Esy2526Extract,
    pageCount: '15 Pages',
    fileSize: '492 KB',
    tags: ['Annexure 4', 'ESY 2025-26', 'Tender 22376', 'OMC Procurement'],
  },
  {
    id: 'annx3-esy24-25-tender-extract',
    title: 'Annexure 3: OMC Tender Extract (ESY 2024-25)',
    shortTitle: 'Tender Extract: ESY 2024-25 (916 Cr L)',
    category: 'annexure',
    categoryLabel: 'OMC Tender Extract',
    authority: 'Oil Marketing Companies (IOCL, BPCL, HPCL)',
    authorityType: 'OMC Procurement',
    date: '26 Sep 2024',
    referenceNo: 'E-Tender No: 17893',
    summary:
      'Tender terms, quantity bidding procedures, and allocation framework for procurement of ~916 crore litres of denatured anhydrous ethanol across OMC depots for the 2024-25 supply cycle.',
    pdfUrl: annx3Esy2425Extract,
    pageCount: '10 Pages',
    fileSize: '468 KB',
    tags: ['Annexure 3', 'ESY 2024-25', 'Tender 17893', '916 Cr Litres'],
  },
  {
    id: 'annx2-bpa-eoi2-extract',
    title: 'Annexure 2: Bipartite Agreement Extract (EOI 02)',
    shortTitle: 'BPA Extract: EOI 02 Scheme',
    category: 'annexure',
    categoryLabel: 'Commercial Agreement Extract',
    authority: 'Oil Marketing Companies & Distillers',
    authorityType: 'OMC Procurement',
    date: 'December 2025',
    referenceNo: 'EOI-02 CBPL/BPA',
    summary:
      'Key provisions and clauses extract from the tripartite/bipartite agreement executed between project proponents and OMCs under EOI 02, covering offtake guarantees, defaults, and price indexing.',
    pdfUrl: annx2BpaEoi2Extract,
    pageCount: '2 Pages',
    fileSize: '511 KB',
    tags: ['Annexure 2', 'EOI 02', 'BPA Clauses', 'Offtake Guarantee'],
  },
  {
    id: 'annx1-bpa-eoi1',
    title: 'Annexure 1: Bipartite Agreement Framework (EOI 01)',
    shortTitle: 'BPA Framework: EOI 01 Foundation',
    category: 'annexure',
    categoryLabel: 'Foundational Agreement',
    authority: 'Oil Marketing Companies & DEPs',
    authorityType: 'OMC Procurement',
    date: 'February 2022',
    referenceNo: 'EOI-01 Foundation Contract',
    summary:
      'The foundational 10-year Long-Term Offtake Agreement (LTOA / BPA) executed by upcoming Dedicated Ethanol Plants in ethanol-deficit states under the landmark EOI 01 initiative.',
    pdfUrl: annx1BpaEoi1,
    pageCount: '25 Pages',
    fileSize: '6.8 MB',
    tags: ['Annexure 1', 'EOI 01', 'LTOA Master Contract', '10-Year Offtake'],
  },
];
